import { render } from "./LogBags.vue?vue&type=template&id=1f499ed2&scoped=true&ts=true"
import script from "./LogBags.vue?vue&type=script&lang=ts"
export * from "./LogBags.vue?vue&type=script&lang=ts"

import "./LogBags.vue?vue&type=style&index=0&id=1f499ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f499ed2"]])

export default __exports__